import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import {
  Link,
  Box,
  Typography,
  Button,
  Slide,
  List,
  ListItem,
  Tab,
  Select,
  MenuItem,
  Slider,
} from "@mui/material";
import Popover from "@mui/material/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import { useMutation, useQuery } from "react-query";
import fetcher from "../../src/dataProvider";
import { STRAPI_API_URL } from "../../src/constant/appConstants";
import { verifyEmail } from "../../util/validators";
import { Label } from "@mui/icons-material";
import TagManager from "react-gtm-module";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "../Home/Footer";

const useStyles = makeStyles((theme) => ({
  investmentBox: {
    position: "relative",
    display: "block",
    background: "rgba(48, 39, 72, 0.9)",
    backdropFilter: "blur(74px)",
    borderRadius: "12px",
    padding: "20px 12px 9px",
    width: "100%",
    // maxWidth: "284px",
    margin: "auto",
    "& p": {
      color: "#fff",
      fontSize: "25px",
      fontWeight: "500",
      marginBottom: "12px",
      textAlign: "left",
    },
    "@media(max-width:767px)": {
      maxWidth: "315px",
    },
  },
  amount: {
    color: "#fff",
    fontSize: "16px",
    fontWeight: "700",
    paddingLeft: "3px",
    cursor: "pointer",
  },
  amountLg: {
    color: "#E14084",
    fontSize: "74px",
    fontWeight: "500",
    "& span": {
      color: "#fff",
      fontSize: "34px",
      fontWeight: "500",
    },
  },
  thumbCardBox: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "46px",
    "& img": {
      width: "70px",
      height: "70px",
      borderTadius: "4px",
      objectFit: "cover",
      margin: "auto",
      display: "block",
    },
  },
  rangeSliderBox: {
    width: "100%",
    position: "relative",
    display: "block",
    margin: "0 auto 15px",
    borderRadius: "10px",
    padding: "10px 0",
    "& .MuiSlider-thumb": {
      background: "linear-gradient(90.78deg, #B237F6 3.91%, #E94177 96.03%);",
      borderRadius: "4px",
      minWidth: "20px",
      height: "20px",
      color: "#000",
      "&:after": {
        display: "none !important",
      },
      "&:hover": {
        boxShadow: "none",
      },
    },
    "& .MuiSlider-root": {
      height: "2px",
      marginBottom: "0",
    },
    "& .MuiSlider-track": {
      background: "#E94177",
      border: "none",
    },
    "& .MuiSlider-mark": {
      background: "#511F49",
      width: "1px",
    },
    "& .MuiSlider-markActive": {
      background: "#E94177",
    },
    "& .MuiSlider-rail": {
      background: "#511F49",
      opacity: "1",
    },
    "& .MuiSlider-valueLabel": {
      top: "100px",
      padding: "0 7px",
      height: "18px",
      width: "18px",
      left: "69px",
      background:
        "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
    },
    "& .MuiSlider-markLabel": {
      color: "rgba(255, 255, 255, 0.7)",
      fontSize: "10px",
      top: "19px",
    },
  },
  shortContent: {
    position: "absolute",
    // width: "191px",
    height: "34px",
    left: "41px",
    top: "137px",
    marginTop: "20px",

    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "17px",
    textAlign: "center",

    color: "#FFFFFF",
  },
  partnersSection: {
    padding: "120px 25px 0",
    maxWidth: "1280px",
    margin: "auto",
    fontFamily: "'Inter',sans-serif !important",
    "@media (max-width:480px)": {
      padding: "0 10px 0",
      margin: "0 auto 40px",
    },
  },
  partnersTitleH1: {
    textAlign: "center",
    color: "#fff",
    fontSize: "42px",
    fontWeight: "700",
    lineHeight: "51px",
    marginBottom: "48px",
    "@media (max-width:480px)": {
      fontSize: "24px",
      fontWeight: "600",
      marginBottom: "20px",
    },
  },
  partnersRow: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  newsImage: {
    width: "100%",
    objectFit: "contain",
    maxHeight: "32px",
  },
  newsLogoList: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    overflowX: "auto",
    overflowY: "hidden",
    width: "100%",
    padding: "0 15px",
    justifyContent: "center",
    alignItems: "center",
    "& li": {
      width: "237px",
      height: "0px",
      border: "2px solid #FFFFFF",
      position: "absolute",
      left: "24px",
      top: "111px",
      opacity: "0.5",
    },
    "& img": {
      width: "100%",
    },
  },
  followUsIcons: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    paddingBottom: "120px",
    "@media(max-width:480px)": {
      display: "grid",
      gridTemplateColumns: "auto auto auto",
      justifyContent: "unset",
    },
    "& > div": {
      margin: "0 34px",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      "@media(max-width:480px)": {
        margin: "0 24px",
      },
    },
    "& > div > a": {
      position: "relative",
      display: "block",
      textAlign: "center",
      color: "#fff",
      textDecoration: "none",
    },
    "& > div > a > div": {
      padding: "20px 0",
    },
    "& img": {
      width: "76px",
      height: "76px",
    },
    "@media (max-width:767px)": {
      "& > div > a": {
        maxWidth: "75px",
      },
      "& > div > a img": {
        width: "100%",
      },
      "& > div": {
        marginBottom: "25px",
      },
    },
  },
  iconName: {
    "@media(max-width:480px)": {
      padding: "10px 0",
    },
  },
  shadowBlur: {
    position: "absolute",
    bottom: "0",
    left: "50%",
    transform: "translateX(-50%)",
    filter: "blur(37px)",
    opacity: "0.2",
  },
  clientList: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "1005px",
    padding: "0",
    "& li": {
      width: "100%",
      maxWidth: "164.55px",
      margin: "0 18px 36px",
      padding: "0",
    },
    "@media (max-width:480px)": {
      "& li": {
        maxWidth: "145px",
        margin: "0 10px 20px",
      },
    },
    "& img": {
      width: "100%",
    },
  },
  investmentList: {
    position: "relative",
    display: "block",
    padding: "0 !important",
    marginTop: "24px !important",
    "& li": {
      position: "relative !important",
      display: "flex !important",
      padding: "0  !important",
      marginBottom: "16px !important",
      justifyContent: "space-between !important",
      alignItems: "center !important",
      "& > img": {
        width: "60px !important",
        height: "60px !important",
        borderRadius: "12px",
      },
    },
  },
  songName: {
    width: "100%",
    padding: "0 12px",
    lineHeight: "10px !important",
    "& p": {
      fontSize: "16px !important",
      fontWeight: "700 !important",
      color: "#fff !important",
      margin: "0 !important",
    },
    "& small": {
      fontSize: "12px",
      fontWeight: "400",
      color: "#fff",
      opacity: "0.75",
    },
  },
  songPrice: {
    textAlign: "right !important",
    whiteSpace: "nowrap !important",
    lineHeight: "18px",
    "& p": {
      fontSize: "16px !important",
      fontWeight: "600 !important",
      color: "#E14084 !important",
      margin: "0 !important",
      lineHeight: "10px !important",
    },
    "& small": {
      fontSize: "16px !important",
      fontWeight: "400 !important",
      color: "#fff !important",
      lineHeight: "10px !important",
      opacity: "0.75 !important",
    },
  },
  beforeRelease: {
    textAlign: "center",
    fontSize: "10px",
    fontWeight: "400",
    color: "#fff",
    opacity: "0.75",
    marginTop: "20px",
    position: "relative",
    display: "block",
  },
  howItWorksSection: {
    padding: "120px 72px 0",
    width: "100%",
    fontFamily: "'Inter',sans-serif !important",
    "@media (max-width:480px)": {
      padding: "0 10px 0",
      margin: "40px auto",
    },
  },
  howItWorks: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    "& > div": {
      width: "50%",
      "@media(max-width:480px)": {
        width: "100%",
      },
    },
    "@media(max-width:992px)": {
      "& > div": {
        width: "100%",
      },
    },
  },
  howItWorksRow: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: "20px",
    justifyContent: "center",
    position: "relative",
    alignItems: "start",
    marginBottom: "35px",
    "@media (max-width:767px)": {
      textAlign: "center",
      marginBottom: "80px",
      "&:nth-of-type(odd)::after": {
        display: "none",
      },
      "&::after": {
        display: "none",
      },
    },
  },
  howItWorksRowImage: {
    width: "100%",
    maxWidth: "132px",
    padding: "30px",
    background: "#1a1728",
    borderRadius: "10px",
    border: "4px solid rgba(255, 255, 255, 0.03)",
    "@media (max-width:767px)": {
      maxWidth: "202px",
    },
  },
  glowImage: {
    maxWidth: "132px",
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    bottom: "-45px",
    opacity: "0.5",
  },
  countNum: {
    fontSize: "24px",
    marginRight: "15px",
    fontWeight: "600",
    lineHeight: "29px",
    color: "#fff",
    "@media (max-width:480px)": {
      fontSize: "24px",
      fontWeight: "500",
      lineHeight: "48px",
    },
  },
  hiwRowContent: {
    width: "55%",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "start",
    padding: "0 0 0 24px",
    "@media (max-width:767px)": {
      width: "100%",
      textAlign: "center",
      padding: "30px 0 !important",
    },
  },
  hiwContentBox: {
    width: "100%",
  },
  hiwRowContentTitle: {
    width: "100%",
    lineHeight: "28px",
    fontSize: "24px",
    color: "#fff",
    fontWeight: "600",
    display: "flex",
    alignItems: "start",
    "@media (max-width:992px)": {
      width: "100%",
      textAlign: "left",
      alignItems: "start",
    },
    "@media (max-width:480px)": {
      fontSize: "24px",
      fontWeight: "600",
    },
  },
  hiwImageSeparator: {
    width: "100%",
    height: "2.7px",
    background: "#fff",
    borderRadius: "7px",
    boxShadow: "0px 0px 20px 1px #ff3780",
    margin: "20px 0 20px 40px",
    "@media (max-width:767px)": {
      margin: "40px 0 20px 0",
    },
    "@media (max-width:480px)": {
      margin: "25px 0 20px 35px",
    },
  },
  hiwRowContentDescription: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    color: "#fff",
    margin: "0",
    display: "block",
    paddingLeft: "40px",
    textAlign: "left",
    "@media (max-width:767px)": {
      paddingLeft: "0",
    },
    "@media (max-width:480px)": {
      fontSize: "14px",
      lineHeight: "20.9px",
      paddingLeft: "35px",
    },
  },
  videoContent: {
    color: "#fff",
    fontSize: "24px",
    fontWeight: "500",
    lineHeight: "33px",
    marginBottom: "10px",
    "@media (max-width:767px)": {
      display: "none",
    },
  },
  ceoSection: {
    position: "relative",
    display: "block",
    background: "#302748",
    padding: "40px 72px",
    "@media (max-width:767px)": {
      padding: "40px 15px",
    },
  },
  ceoMessage: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    margin: "48px auto 0",
    width: "100%",
    maxWidth: "970px",
    "& > div": {
      paddingLeft: "48px",
    },
    "& p": {
      color: "#fff",
      fontStyle: "italic",
      fontSize: "24px",
      fontWeight: "500",
      marginBottom: "21px",
      textAlign: "left",
      "@media (max-width:767px)": {
        fontSize: "20px",
        marginTop: "24px",
        lineHeight: "28px",
      },
    },
    "& span": {
      color: "#fff",
      fontSize: "16px",
      fontWeight: "500",
      display: "block",
    },
    "& span:last-child": {
      color: "#fff",
      fontSize: "16px",
      fontWeight: "400",
      display: "block",
      opacity: "0.75",
    },
    "@media(max-width:767px)": {
      flexWrap: "wrap",
      "& > div": {
        paddingLeft: "0",
        width: "100%",
      },
    },
  },
  dropDownContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "start",
    width: "100%",
    "& img": {
      marginLeft: "2px",
      width: "10px",
    },
  },
  amountDropdown: {
    position: "relative",
    display: "block",
    width: "140px",
    background: "#242033",
    borderRadius: "12px",
    padding: "15px",
    "& li": {
      position: "relative",
      display: "block",
      padding: "5px 0",
      "& label": {
        position: "relative",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        justifyContent: "space-between",
      },
      "& p": {
        fontSize: "14px",
        fontWeight: "400",
        color: "#fff",
      },
      "& input": {
        "-webkit-appearance": "none",
        width: "16px",
        height: "16px",
        "&:checked": {
          background:
            "center/contain no-repeat url(/images/token/pink-tick.svg)",
        },
      },
    },
  },
}));

var settings = {
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  speed: 500,
  slidesToShow: 3,
  centerMore: true,
  centerPadding: "15px",
  autoplaySpeed: 5000,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
  ],
};
export default function Index(props) {
  const { historicalCategory = "Punjabi_Indie" } = props;
  const classes = useStyles();
  const initialValues = {
    email: "",
  };

  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [news, setNews] = useState([]);
  const [newsLength, setNewsLength] = useState("");
  const [priceRange, setPriceRange] = useState(1000);
  const [open, setOpen] = useState(false);
  const [songGetData, setSongGetData] = useState();

  const handleChange = (event, newValue) => {
    setPriceRange(newValue);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const handleChangeform = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const validateform = (values) => {
    setFormErrors({});
    const errors = {};
    if (!verifyEmail(values.email)) {
      errors.email = "Please enter valid email id";
      setFormErrors(errors);
      return false;
    }
    return true;
  };

  const submitNFTForm = (formValues) => {
    let data = {
      email: formValues.email,
    };

    NftLandingForm(data);
  };

  const { mutate: NftLandingForm } = useMutation(
    (data) =>
      fetcher.post(`${STRAPI_API_URL}/interest-forms`, {
        data,
      }),
    {
      onSuccess: (res) => {
        const tagManagerArgs = {
          dataLayer: {
            event: "leadSubmit",
          },
        };
        TagManager.dataLayer(tagManagerArgs);
        setFormValues(initialValues);
      },
    }
  );

  const { data: homeNewsData } = useQuery(
    `${STRAPI_API_URL}/press-releases`,
    () =>
      fetcher.get(`${STRAPI_API_URL}/press-releases`, {
        params: {
          populate: "*",
        },
      })
  );

  useEffect(() => {
    if (homeNewsData) {
      setNews(homeNewsData.data);
      setNewsLength(homeNewsData.data.length);
    }
  }, [homeNewsData]);

  function handleSubmit(e) {
    e.preventDefault();

    if (validateform(formValues)) {
      submitNFTForm(formValues);
    } else {
      console.log(formValues);
      console.log("FormErrors : ", formErrors);
    }
  }

  // const songReturnData = [
  //   {
  //     songName: "Vaste",
  //     songImg: "/images/landing/Vaaste.webp",
  //     singerName: "Dhvani Bhanushali",
  //     returnMoney: 15,
  //   },
  //   {
  //     songName: "Laung Laachi",
  //     songImg: "/images/landing/Laung-Laachi.webp",
  //     singerName: "Mannat Noor",
  //     returnMoney: 12,
  //   },
  //   {
  //     songName: "Swag Se Swagat",
  //     songImg: "/images/landing/Swag-se-Swaagat.webp",
  //     singerName: "Afsana Khan",
  //     returnMoney: 9,
  //   },
  //   {
  //     songName: "Lahore",
  //     songImg: "/images/landing/Lahore.webp",
  //     singerName: "Guru",
  //     returnMoney: 9,
  //   },
  //   {
  //     songName: "Daru Badnaam",
  //     songImg: "/images/landing/Daru-Badnaam.webp",
  //     singerName: "Kamal Kahlon",
  //     returnMoney: 8.5,
  //   },
  // ];

  const { data: songData } = useQuery(
    `${STRAPI_API_URL}/historical-calculators?&filters[song_category]?populate=${historicalCategory}`,
    () =>
      fetcher.get(
        `${STRAPI_API_URL}/historical-calculators?&filters[song_category]?populate=${historicalCategory}`,
        {
          params: {
            populate: historicalCategory,
          },
        }
      )
  );

  useEffect(() => {
    if (songData?.data) {
      setSongGetData(songData?.data);
      console.log("songData@@@", songData);
    } else {
      return null;
    }
  }, [songData]);

  const data = [
    {
      name: "Discord",
      src: "/images/home/social/discord.svg",
      openNewTab: true,
      url: " https://discord.gg/qr2xB7HZRs?utm_source=Email&utm_medium=Community%20announcement&utm_campaign=1",
    },
    {
      name: "Telegram",
      src: "/images/home/social/telegram.svg",
      openNewTab: true,
      url: "https://t.me/+6ldTYbzU1epmMmU9?utm_source=Email&utm_medium=Community%20announcement&utm_campaign=1",
    },
    {
      name: "Twitter",
      src: "/images/home/social/twitter.svg",
      openNewTab: true,
      url: " https://twitter.com/FanTiger_com?utm_source=Email&utm_medium=Community%20announcement&utm_campaign=1",
    },
    {
      name: "Medium",
      src: "/images/home/social/medium.svg",
      openNewTab: true,
      url: " https://medium.com/@fantiger?utm_source=Email&utm_medium=Community%20announcement&utm_campaign=1",
    },
    {
      name: "YouTube",
      src: "/images/home/social/youtube.svg",
      openNewTab: true,
      url: " https://www.youtube.com/channel/UCIdKpJFO7wQls-MvJhLxtVw?utm_source=Email&utm_medium=Community%20announcement&utm_campaign=1",
    },
    {
      name: "Instagram",
      src: "/images/home/social/instagram.svg",
      openNewTab: true,
      url: " https://www.instagram.com/fantiger_com/?utm_source=Email&utm_medium=Community%20announcement&utm_campaign=1",
    },
    {
      name: "Facebook",
      src: "/images/home/social/facebook.svg",
      openNewTab: true,
      url: "https://www.facebook.com/FanTiger.india/?utm_source=Email&utm_medium=Community%20announcement&utm_campaign=1",
    },
  ];

  // console.log("Print Price value ===", priceRange);
  function convertPrice(value) {
    var val = Math.abs(value);
    if (val >= 10000000) {
      val = (val / 10000000).toFixed(1) + " Cr";
    } else if (val >= 100000) {
      val = (val / 100000).toFixed(1) + " Lacs";
    }
    return val;
  }

  return (
    <>
      <Box className={classes.investmentBox}>
        <Box className={classes.dropDownContainer}>
          <PopupState variant="popover" popupId="demo-popup-popover">
            {(popupState) => (
              <>
                <Box
                  className={classes.dropDownContainer}
                  {...bindTrigger(popupState)}
                  // onClick={handleOpen}
                >
                  <Box className={classes.rangeSliderBox}>
                    <Typography
                      component="p"
                      style={{
                        cursor: "pointer",
                        textAlign: "center",
                        fontSize: "18px",
                      }}
                      onClick={handleOpen}
                    >
                      If you had invested*
                      <Box>
                        <Typography
                          component="span"
                          className={classes.amount}
                          onClick={handleOpen}
                          style={{ fontSize: "28px" }}
                        >
                          ₹ {priceRange.toLocaleString("en-IN")}{" "}
                        </Typography>
                      </Box>{" "}
                    </Typography>
                    <Slider
                      value={priceRange}
                      min={0}
                      step={5000}
                      max={100000}
                      defaultValue={1000}
                      onChange={handleChange}
                      // valueLabelDisplay="auto"
                      aria-labelledby="non-linear-slider"
                      marks
                      //marks={marks}
                    />
                  </Box>
                </Box>
                <Popover
                  {...bindPopover(popupState)}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={open}
                  onClose={handleClose}
                ></Popover>
              </>
            )}
          </PopupState>
        </Box>
        <Typography component="span" className={classes.shortContent}>
          You could have theoretically made
        </Typography>
        <List className={classes.investmentList}>
          {songGetData &&
            songGetData?.length > 0 &&
            songGetData.map((data, i) => (
              <Box key={i}>
                <ListItem>
                  <Box component="img" src={data?.attributes?.image_url} />
                  <Box className={classes.songName}>
                    <Typography component="p">
                      {data?.attributes?.song_name}
                    </Typography>
                    <Typography component="small">
                      {data?.attributes?.singer_name}
                    </Typography>
                  </Box>
                  <Box className={classes.songPrice}>
                    <Typography component="p">
                      ₹
                      {convertPrice(
                        data?.attributes?.roi * priceRange
                      ).toLocaleString("en-IN")}
                    </Typography>
                    <Typography component="small">
                      ({data?.attributes?.roi}x)
                    </Typography>
                  </Box>
                </ListItem>
              </Box>
            ))}
        </List>
        <Typography className={classes.beforeRelease} variant="span">
          *before release
        </Typography>
      </Box>
    </>
  );
}
